import React, { useEffect, useState } from "react";
import { getUrl } from "aws-amplify/storage";
import { Image } from 'react-bootstrap';
import { IPost } from "../../Types/models";
// import FastImage from 'react-native-fast-image';
import { S3_BUCKET , DEFAULT_USER_IMAGE } from "../../config";

interface IUserImage {
    post: IPost;
    image: string;
    avatarStyle: any;
};

const PostImage = ({post, image, avatarStyle}: IUserImage) => {
    const [imageUri, setImageUri] = useState<string>(S3_BUCKET+ (post ? (post.image ? post.image : '') : ''));

    useEffect(() => {
        if (post && post.description) {
            getImageUrl();
        }
    }, [post]);

    const getImageUrl = async () => {
        if (post && post.description) {
            const response = await getUrl({
                key: image,//post.image,
            });
            const origin = response.url.origin;
            const path = response.url.pathname.split('%20')[0];
            const uri = origin + path;
            setImageUri(uri);
            // setImageUri(response?.url.toString());
        };
    };
    
    return (
        <>
            {imageUri != S3_BUCKET ?
                <>
                    <Image src={imageUri} className={avatarStyle}/>
                </>
                
            :
                <Image src={DEFAULT_USER_IMAGE} className={avatarStyle} />
            }
        </>
    );
};

export default PostImage;